
export default function Education() {
  return (
    <section className="relative py-24 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold mb-4 bg-gradient-to-r from-white via-purple-200 to-pink-200 bg-clip-text text-transparent">
            My Education
          </h2>
        </div>

        {/* Education Card */}
        <div className="max-w-4xl mx-auto">
          <div className="group relative p-8 bg-gradient-to-br from-cyan-900/20 to-blue-900/20 rounded-3xl border border-cyan-500/20 hover:border-cyan-500/50 transition-all duration-500 hover:scale-105">
            {/* Glow effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-cyan-500 to-blue-600 opacity-0 group-hover:opacity-10 rounded-3xl blur-xl transition-opacity duration-500"></div>
            
            <div className="relative z-10">
              {/* Badge */}
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-cyan-500 to-blue-600 rounded-full text-sm font-semibold mb-6 shadow-lg shadow-cyan-500/50">
                2025 – 2027 (Expected)
              </div>

              {/* Title */}
              <h3 className="text-3xl font-bold mb-4 text-white group-hover:text-cyan-300 transition-colors duration-300">
                Bachelor of Commerce
              </h3>

              {/* Description */}
              <p className="text-gray-300 text-lg leading-relaxed">
                Focus on graphic design, branding, and digital communication. Building a strong foundation in visual arts and business strategy to create impactful designs that drive results.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
